// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_compare-block.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--compare-block';
var CAROUSEL_CLASS = 'carousel--compare-block';
var CAROUSEL_SECTION_SELECTOR = '.compare-block';
var CAROUSEL_SECTION_CLASS = 'compare-block';
var SCROLLBAR_SELECTOR = '.swiper-scrollbar';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));

  // Generate unique classes for slider's scrollbar
  element.querySelector(SCROLLBAR_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-scrollbar-").concat(index));

  // Count the slides in the markup
  var totalSlides = element.querySelectorAll('.swiper-slide').length;
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Scrollbar, A11y, Keyboard],
    slidesPerView: 1.7,
    // Default number of slides to show
    spaceBetween: 0,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.
    keyboard: true,
    observer: true,
    observeParents: true,
    a11y: true,
    breakpoints: {
      400: {
        slidesPerView: 2.1,
        spaceBetween: 0
      },
      414: {
        slidesPerView: 2.7,
        spaceBetween: 0
      },
      768: {
        slidesPerView: totalSlides <= 4 ? totalSlides : 4.7,
        spaceBetween: 0
      },
      1080: {
        slidesPerView: totalSlides < 7 ? totalSlides : 6,
        spaceBetween: 0
      }
    },
    scrollbar: {
      el: "".concat(CAROUSEL_SECTION_SELECTOR, "-scrollbar-").concat(index),
      hide: false,
      draggable: true
    },
    on: {
      afterInit: function afterInit() {
        // Using IntersectionObserver to update the row heights at the latest possible time.
        // Otherwise, the heights can be off since asset load times can vary.
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              syncCompareRowHeights();
              observer.unobserve(entry.target);
            }
          });
        }, {
          root: null,
          rootMargin: '0px 0px -200px 0px',
          threshold: 0
        });
        if (element) {
          observer.observe(element);
        }
      }
    }
  });
});
function syncCompareRowHeights() {
  console.log('Syncing compare row heights...');
  var labelRows = document.querySelectorAll('.js--column-labels table tr');
  var productSlides = document.querySelectorAll('.js--compare-slide');

  // Reset all row heights first (important!)
  labelRows.forEach(row => row.style.height = '');
  productSlides.forEach(slide => {
    slide.querySelectorAll('tr').forEach(row => {
      row.style.height = '';
    });
  });
  var rowCount = labelRows.length;
  var _loop = function _loop(i) {
    var maxHeight = 0;

    // Measure label row
    var labelRow = labelRows[i];
    if (labelRow) {
      maxHeight = labelRow.offsetHeight;
    }

    // Measure same-index rows in product slides
    productSlides.forEach(slide => {
      var rows = slide.querySelectorAll('tr');
      var row = rows[i];
      if (row && row.offsetHeight > maxHeight) {
        maxHeight = row.offsetHeight;
      }
    });

    // Apply max height
    if (labelRow) labelRow.style.height = "".concat(maxHeight, "px");
    productSlides.forEach(slide => {
      var row = slide.querySelectorAll('tr')[i];
      if (row) row.style.height = "".concat(maxHeight, "px");
    });
  };
  for (var i = 0; i < rowCount; i++) {
    _loop(i);
  }
}
var resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    // Optional: update Swiper first if needed
    document.querySelectorAll(CAROUSEL_SELECTOR).forEach(swiperEl => {
      var swiperInstance = swiperEl.swiper;
      if (swiperInstance) swiperInstance.update();
    });

    // Then re-sync heights
    syncCompareRowHeights();
  }, 200);
});